import React, { useState } from "react";
import Checkbox, {
  checkboxStates,
} from "@visiblethread/react-components/dist/components/Checkbox";
import PropTypes from "prop-types";
import multiWorkspaces from "icons/multiWorkspaces.svg";

const AddUserModalUser = ({
  u,
  checkedUsers,
  handleChange,
  hasMultipleWorkspaces,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      className="add__user__modal__users__container__user"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      data-testid="add-user-modal-user"
    >
      {hover ? (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
        <div className="highlight" onClick={() => handleChange(u)} />
      ) : null}
      <span className="add__user__modal__users__container__user__name">
        {u}
      </span>
      {hasMultipleWorkspaces ? (
        <img src={multiWorkspaces} alt="multiWorkspaces" />
      ) : (
        <span style={{ flexBasis: "10%" }}>&nbsp;</span>
      )}
      <span className="add__user__modal__users__container__user__checkbox">
        <Checkbox
          state={
            checkedUsers.find((user) => user === u)
              ? checkboxStates.checked
              : checkboxStates.empty
          }
          handleChange={() => {
            handleChange(u);
          }}
          disabled={false}
          id="cbAddUser"
          value="add_user_checkbox"
        />
      </span>
    </div>
  );
};

export default AddUserModalUser;

AddUserModalUser.propTypes = {
  u: PropTypes.string.isRequired,
  checkedUsers: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleChange: PropTypes.func.isRequired,
  hasMultipleWorkspaces: PropTypes.bool.isRequired,
};
